module.exports = __webpack_public_path__ + "img/join-2.931e4f27.png";